"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/lib/analytics.ts
var analytics_exports = {};
__export(analytics_exports, {
  loggerAction: () => loggerAction,
  loggerError: () => loggerError,
  loggerInfo: () => loggerInfo,
  loggerWarn: () => loggerWarn
});
module.exports = __toCommonJS(analytics_exports);
var import_browser_logs = require("@datadog/browser-logs");
var import_browser_rum = require("@datadog/browser-rum");
var getLoggerTitle = (key, description) => !description ? key : `${key}: ${description}`;
var generateStackTrace = () => {
  const error = new Error();
  return error.stack;
};
var loggerError = ({
  key = "",
  description = "",
  data
}) => {
  if (!document)
    return;
  import_browser_logs.datadogLogs.logger.error(getLoggerTitle(key, description), {
    data,
    trace: generateStackTrace()
  });
};
var loggerWarn = ({
  key = "",
  description = "",
  data
}) => {
  if (!document)
    return;
  import_browser_logs.datadogLogs.logger.warn(getLoggerTitle(key, description), {
    data,
    trace: generateStackTrace()
  });
};
var loggerInfo = ({
  key = "",
  description = "",
  data
}) => {
  if (!document)
    return;
  import_browser_logs.datadogLogs.logger.info(getLoggerTitle(key, description), {
    data,
    trace: generateStackTrace()
  });
};
var loggerAction = ({
  action = "",
  page = "",
  data
}) => {
  if (!document)
    return;
  import_browser_rum.datadogRum.addAction(action, {
    data,
    page,
    trace: generateStackTrace()
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  loggerAction,
  loggerError,
  loggerInfo,
  loggerWarn
});
